import * as React from 'react';
import { Button, Grid, Icon, IconSize, IconType } from 'ui-toolkit';

interface IPreviewButtonBlock {
  finalizedSuccess: boolean;
  disableFinalizeButton: boolean;
  onFinalizeClick: () => void;
}

const PreviewButtonBlock: React.FunctionComponent<IPreviewButtonBlock> = (props) => {
  const onFinalizeClick = () => {
    if (!props.disableFinalizeButton) {
      props.onFinalizeClick();
    }
  };

  return (
    <Grid columnCount={props.finalizedSuccess ? 2 : 1} alignItems={'center'}>
      {props.finalizedSuccess ? <Icon type={IconType.Check} size={IconSize.Small} /> : null}
      <Button
        intent="primary"
        className={props.disableFinalizeButton ? 'primary-button--disable' : ''}
        onClick={onFinalizeClick}
      >
        Finalize
      </Button>
    </Grid>
  );
};

export default PreviewButtonBlock;
